import React, { useEffect } from 'react'
import Slider from '../Component/Homes/Slider'
import '../Css/Sujal.css'
import About from '../Component/Homes/About'
import Skill from '../Component/Homes/Skill'
import Technologies from '../Component/Homes/Technologies'
import CoreService from '../Component/Homes/CoreService'
import SoftDev from '../Component/Homes/SoftDev'
import { HowWork } from '../Component/Homes/HowWork'
import JoinFamily from '../Component/Homes/JoinFamily'
import Last from '../Component/Homes/Last'
const Home = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <div>
      <Slider />
      <About />
      <Skill />
      <Technologies />
      <CoreService />
      <SoftDev />
      <HowWork />
      <JoinFamily />
      <Last />
    </div>
  )
}

export default Home